export const BASE_DOMAIN = process.env.REACT_APP_API_URL!;
export const BASE_DOMAIN_UPLOAD = process.env.REACT_APP_UPLOAD_URL!;
